<app-input
  [placeholder]="placeHolderText"
  [formCntlName]="searchValue"
  [inputType]="textInputType"
  [suffixInputIcon]="iconName"
  (keyup)="applyFilter($event)"
>
</app-input>
